<template>
  <NavbarFive class="home_one" />
  <ResponsiveNavbarFive class="home_one" />
  <PageBanner pageTitle="Pricing Plan" mainTitle="Pricing Plan" />
  <PricingPlan />
  <DownloadTheApp />
  <MainFooter />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import NavbarFive from "../components/Layouts/NavbarFive.vue";
import ResponsiveNavbarFive from "../components/Layouts/ResponsiveNavbarFive.vue";
import PageBanner from "../components/Common/PageBanner.vue";
import PricingPlan from "../components/Pricing/PricingPlan.vue";
import DownloadTheApp from "../components/Common/DownloadTheApp.vue";
import MainFooter from "../components/Layouts/MainFooter.vue";

export default defineComponent({
  name: "PricingPage",
  components: {
    NavbarFive,
    ResponsiveNavbarFive,
    PageBanner,
    PricingPlan,
    DownloadTheApp,
    MainFooter,
  },
});
</script>